import React, { forwardRef } from "react";
import Stack from "../Stack/Stack";
import Text from "../Text/Text";
import {
  InputContainer,
  Label,
  Prefix,
  Span,
  StyledInput,
  Suffix
} from "./style";
import FieldMessage from "../FieldMessage/FieldMessage";

export interface InputProps
  extends Omit<React.ComponentPropsWithRef<"input">, "prefix"> {
  errorMessage?: string | null;
  typeFieldMessage?: "error" | "warning" | "info";
  label?: string;
  optional?: boolean;
  helperText?: string;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const {
    "aria-label": ariaLabel,
    label,
    optional,
    helperText,
    prefix,
    suffix,
    errorMessage,
    typeFieldMessage = "error",
    ...htmlProps
  } = props;
  const invalid = !!errorMessage;

  return (
    <Stack spacing={{ mobile: 8, desktop: 12 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        spacing={{ mobile: 8, desktop: 12 }}
      >
        <Label aria-label={ariaLabel}>
          <Text size="small">{label}</Text>
        </Label>
        {errorMessage && (
          <Span>
            <Text size="small">{helperText}</Text>
          </Span>
        )}
        {optional && (
          <Span>
            <Text size="small">Opcional</Text>
          </Span>
        )}
      </Stack>
      <InputContainer typeFieldMessage={typeFieldMessage} invalid={invalid}>
        {prefix && <Prefix>{prefix}</Prefix>}
        <StyledInput ref={ref} aria-invalid={invalid} {...htmlProps} />
        {suffix && <Suffix>{suffix}</Suffix>}
      </InputContainer>
      {errorMessage && <FieldMessage>{errorMessage}</FieldMessage>}
    </Stack>
  );
});

export default Input;
